<template>
  <div id="gate_index">
    <dv-full-screen-container class="bg">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <!-- 第一行标题装饰条 -->
        <div class="d-flex jc-center" style="height: 5vh">
          <dv-decoration-10
            :color="['#1370fb', '#1370fb']"
            style="width: 20%; height: 0.0625rem"
          />
          <div class="d-flex jc-center" style="width: 60%">
            <dv-decoration-8
              :color="['#1370fb', '#000000']"
              style="width: 20%; height: 0.625rem"
            />
            <div class="title" style="width: 60%">
              <span class="title-text">{{ title }}</span>
              <dv-decoration-5
                class="title-bototm"
                :color="['#1370fb', '#1370fb']"
                style="width: 3.8rem; padding-top: 0.18rem"
              />
            </div>
            <dv-decoration-8
              :reverse="true"
              :color="['#1370fb', '#000000']"
              style="width: 20%; height: 0.625rem"
            />
          </div>
          <dv-decoration-10
            :color="['#1370fb', '#1370fb']"
            style="width: 20%; height: 0.0625rem; transform: rotateY(180deg)"
          />
        </div>

        <!-- 第二行 -->
        <div class="d-flex jc-between px-2" style="height: 5vh">
          <div class="d-flex" style="width: 40%">
            <div
              class="react-right ml-4"
              style="width: 5rem; background-color: #0f1325"
            >
              <span class="react-before"></span>
              <div
                style="
                  float: left;
                  transform: skewX(-45deg);
                  font-weight: 600;
                  font-size: 0.26rem;
                "
              ></div>
            </div>
            <div
              class="react-right ml-3"
              style="width: 5rem; background-color: #0f1325"
            ></div>
          </div>
          <div style="width: 40%" class="d-flex">
            <div
              class="react-left mr-3"
              style="width: 5rem; background-color: #0f1325"
            ></div>
            <div
              class="react-left mr-4"
              style="width: 5rem; background-color: #0f1325; text-align: right"
            >
              <span class="react-after"></span>
              <span class="text" style="font-size: 0.26rem">{{ date }}</span>
            </div>
          </div>
        </div>
        <div class="body-box">
          <!-- 第三行数据 -->
          <div class="content-box">
            <div style="height: 42vh">
              <dv-border-box-12>
                <top1 />
              </dv-border-box-12>
            </div>
            <div style="height: 42vh">
              <dv-border-box-12>
                <top2 />
              </dv-border-box-12>
            </div>
            <div style="height: 42vh">
              <dv-border-box-12>
                <top3 />
              </dv-border-box-12>
            </div>
          </div>

          <!-- 第四行数据 -->
          <div class="bototm-box">
            <dv-border-box-1 style="height: 42vh">
              <bottom1 />
            </dv-border-box-1>
            <dv-border-box-1 style="height: 42vh">
              <bottom2 />
            </dv-border-box-1>
          </div>
        </div>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
var storage = window.localStorage;
var title = storage.getItem("title");
if (title == "false") {
  title = "智慧闸机大数据看板";
}
import top1 from "./top1";
import top2 from "./top2";
import top3 from "./top3";
import bottom1 from "./bottom1";
import bottom2 from "./bottom2";
export default {
  data() {
    return {
      loading: true,
      title: title,
      date: this.dateFormatToString(new Date()),
    };
  },
  components: {
    top1,
    top2,
    top3,
    bottom1,
    bottom2,
  },
  mounted() {
    this.cancelLoading();
    // 定时刷新时间
    let _this = this;
    // 定时器
    setInterval(() => {
      _this.date = _this.dateFormatToString(new Date()); // 修改数据date
    }, 1000);
  },
  methods: {
    //关闭loading加载条
    cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    initData() {
      this.$http.get("/dataView/getGateIndexInfo").then((res) => {
        console.log(res);
      });
    },
    //日期格式化
    dateFormatToString(data) {
      let formatDateTime;
      let Y = data.getFullYear();
      let M = data.getMonth() + 1;
      let D = data.getDate();
      let H = data.getHours();
      let Min = data.getMinutes();
      let S = data.getSeconds();
      let W = data.getDay();
      H = H < 10 ? "0" + H : H;
      Min = Min < 10 ? "0" + Min : Min;
      S = S < 10 ? "0" + S : S;
      switch (W) {
        case 0:
          W = "天";
          break;
        case 1:
          W = "一";
          break;
        case 2:
          W = "二";
          break;
        case 3:
          W = "三";
          break;
        case 4:
          W = "四";
          break;
        case 5:
          W = "五";
          break;
        case 6:
          W = "六";
          break;
        default:
          break;
      }
      formatDateTime =
        Y + "年" + M + "月" + D + "日 " + H + ":" + Min + ":" + S + " 星期" + W;
      this.date = formatDateTime;
      return formatDateTime;
    },
  },
  // 注意在vue实例销毁前，清除我们的定时器。
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/gateIndex.scss";
#gate_index {
  .title {
    line-height: 0.8rem;

    .title-text {
      font-size: 0.45rem !important;
      width: 100%;
      font-weight: 600;
      background-image: linear-gradient(135deg, #00e2ff, #da00ff);
      -webkit-background-clip: text;
      color: transparent;
    }
  }
}
</style>
